import Repository from './Repository.js';

class PlacesRepository extends Repository {
    async getPlaces(query) {
        return await this.get('places', query);
    }
}

export default new PlacesRepository();
